module.exports = __webpack_public_path__ + "img/instore.0a5dea4a.png";